import { FC, ReactNode, useEffect, useReducer, useRef } from "react";

import dayjs, { duration } from "dayjs";
import { Duration } from "dayjs/plugin/duration";

export const Timeout: FC<{
  howLong: number;
  children: (props: { timeLeft: Duration; isEnded: boolean }) => ReactNode;
  onEnd?: () => void;
}> = ({ children, onEnd, howLong }) => {
  const [, forceRender] = useReducer(() => ({}), {});

  const endsOnRef = useRef(dayjs().add(howLong));

  const $toRefs = { onEnd };
  const toRefs = useRef($toRefs);
  useEffect(() => {
    toRefs.current = $toRefs;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (endsOnRef.current.diff(dayjs()) < 0) toRefs.current.onEnd?.();
      forceRender();
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const millisecondsLeft = endsOnRef.current.diff(dayjs());
  const isEnded = millisecondsLeft <= 0;
  const timeLeft = duration(isEnded ? 0 : millisecondsLeft);

  return <>{children({ timeLeft, isEnded })}</>;
};
